// Estilos exclusivos do AnexosTab (título + conteúdo da seção Anexos) —
// extraídos de circuito/styles.js na Task 6 da decomposição.
const styles = () => ({
	gritItemTitle: {
		display: "flex",
		alignItems: "center",
		gap: 1,
		flexDirection: "row",
		width: "100%",
	},
	contentIdentation: {
		pl: 5,
		pt: 2,
	},
});

export default styles;
